import React from 'react';
import styles from './window.scss';

import { Icon } from '../icons';

const Window = ({ title, children, onCloseClick }) => {
  return (
    <div className="window">
      <div className="inner-window">
        <div className="header">
          <a href="#" onClick={onCloseClick}>
            <Icon type={'cross'} className="window-close"/>
          </a>
          <h2>{title}</h2>
        </div>
        <div className="content">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Window;



// WEBPACK FOOTER //
// ./src/components/layout/Window.js